"use strict";
var _a, _b, _c, _d, _e, _f, _g;
(_a = document.querySelector("header .side-menu-btn")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function () {
    var _a, _b, _c, _d;
    (_a = document.querySelector(".side-nav-container")) === null || _a === void 0 ? void 0 : _a.classList.toggle("d-none");
    (_b = document.querySelector("body")) === null || _b === void 0 ? void 0 : _b.classList.toggle("no-scroll");
    (_c = document.querySelector("header .side-menu-btn .lines")) === null || _c === void 0 ? void 0 : _c.classList.toggle("hidden");
    (_d = document.querySelector("header .side-menu-btn .close-x")) === null || _d === void 0 ? void 0 : _d.classList.toggle("hidden");
});
document.querySelectorAll('header .search').forEach(function (trigger) {
    trigger.addEventListener('click', function handleClick() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // Clear the search input and results
        var searchInput = document.querySelector(".search-section-container input[type='search']");
        searchInput.value = "";
        (_a = document.querySelector(".search-results-container .loading")) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
        (_b = document.querySelector(".search-results-container .results")) === null || _b === void 0 ? void 0 : _b.classList.add("d-none");
        (_c = document.querySelector(".search-results-container .no-results")) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
        // Show hide relevant elements
        (_d = document.querySelector(".search-section-container")) === null || _d === void 0 ? void 0 : _d.classList.toggle("hidden");
        (_e = document.querySelector("header .main-header-content .search .s-icon")) === null || _e === void 0 ? void 0 : _e.classList.toggle("d-none");
        (_f = document.querySelector("header .main-header-content .search .close-x")) === null || _f === void 0 ? void 0 : _f.classList.toggle("d-none");
        (_g = document.querySelector("body")) === null || _g === void 0 ? void 0 : _g.classList.toggle("search-open");
        (_h = document.querySelector(".search-section-container input[type='search']")) === null || _h === void 0 ? void 0 : _h.focus();
    });
});
function debounceSearchInput(callback, wait) {
    var timerId;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timerId);
        timerId = setTimeout(function () {
            callback.apply(void 0, args);
        }, wait);
    };
}
var searchInput = document.querySelector(".search-section-container input[type='search']");
searchInput === null || searchInput === void 0 ? void 0 : searchInput.addEventListener("keyup", debounceSearchInput(function () {
    var _a, _b, _c, _d;
    var value = searchInput.value;
    (_a = document.querySelector(".search-results-container")) === null || _a === void 0 ? void 0 : _a.classList.remove("d-none");
    (_b = document.querySelector(".search-results-container .results")) === null || _b === void 0 ? void 0 : _b.classList.add("d-none");
    (_c = document.querySelector(".search-results-container .loading")) === null || _c === void 0 ? void 0 : _c.classList.remove("d-none");
    (_d = document.querySelector(".search-results-container .no-results")) === null || _d === void 0 ? void 0 : _d.classList.add("d-none");
    // @ts-ignore
    fetch(window.Shopify.routes.root + "search/suggest.json?q=" + encodeURIComponent(value) + "&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title")
        .then(function (response) { return response.json(); })
        .then(function (suggestions) {
        var _a, _b, _c, _d, _e, _f;
        var productSuggestions = suggestions.resources.results.products;
        if (productSuggestions.length > 0) {
            buildSearchResults(productSuggestions.slice(0, 3), productSuggestions.length > 3);
            (_a = document.querySelector(".search-results-container .loading")) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
            (_b = document.querySelector(".search-results-container .results")) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
            (_c = document.querySelector(".search-results-container .no-results")) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
        }
        else {
            (_d = document.querySelector(".search-results-container .loading")) === null || _d === void 0 ? void 0 : _d.classList.add("d-none");
            (_e = document.querySelector(".search-results-container .results")) === null || _e === void 0 ? void 0 : _e.classList.add("d-none");
            (_f = document.querySelector(".search-results-container .no-results")) === null || _f === void 0 ? void 0 : _f.classList.remove("d-none");
        }
    });
}, 300));
function buildSearchResults(products, hasMoreResults) {
    var resultsContainer = document.querySelector(".search-results-container .results");
    if (resultsContainer) {
        resultsContainer.innerHTML = "";
        products.forEach(function (product) {
            var productDiv = "<a href=\"".concat(product.url, "\" class=\"result d-flex align-items-center\">\n        <div>\n          <img src=\"").concat(product.image, "\" alt=\"").concat(product.title, "\" />\n        </div>\n        <div class=\"flex-1\">\n          <div class=\"title\">").concat(product.title, "</div>\n          <div class=\"product-type\">").concat(product.type, "</div>\n        </div>\n      </a>");
            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = productDiv;
            resultsContainer.appendChild(tempDiv);
        });
        if (hasMoreResults) {
            var moreResultsDiv = "<div class=\"more-results\">\n        <a class=\"block-btn gold text-uppercase\" href=\"/search?q=".concat(encodeURIComponent((searchInput === null || searchInput === void 0 ? void 0 : searchInput.value) || ""), "\">See more results\n          <img src=\"https://cdn.shopify.com/s/files/1/0505/3071/3798/files/arrow-right_ba4c4db2-a6d7-458a-b0c1-d712f7ff579f.svg?v=1746011523\" alt=\"Arrow right\">\n        </a>\n      </div>");
            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = moreResultsDiv;
            resultsContainer.appendChild(tempDiv);
        }
    }
}
(_b = document.querySelector("header .cart")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function () {
    var _a;
    (_a = document.querySelector(".sticky-cart")) === null || _a === void 0 ? void 0 : _a.classList.toggle("open");
});
(_c = document.querySelector(".sticky-cart .cart-controls button")) === null || _c === void 0 ? void 0 : _c.addEventListener("click", function () {
    var _a;
    (_a = document.querySelector(".sticky-cart")) === null || _a === void 0 ? void 0 : _a.classList.remove("open");
});
(_d = document.querySelector(".sticky-cart .close")) === null || _d === void 0 ? void 0 : _d.addEventListener("click", function () {
    var _a;
    (_a = document.querySelector(".sticky-cart")) === null || _a === void 0 ? void 0 : _a.classList.remove("open");
});
(_e = document.querySelector(".sticky-cart .empty-cart")) === null || _e === void 0 ? void 0 : _e.addEventListener("click", function (e) {
    var _a;
    e.preventDefault();
    (_a = document.querySelector(".sticky-cart .cart-free-shipping-upsell")) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
    var stickyLoader = document.querySelector(".sticky-cart .cart-loader");
    stickyLoader === null || stickyLoader === void 0 ? void 0 : stickyLoader.classList.remove("d-none");
    var cartItems = document.querySelector(".sticky-cart .cart-items");
    if (cartItems) {
        cartItems.innerHTML = "";
    }
    fetch("/cart/clear", {
        method: "POST"
    }).then(function () {
        cart.update_cart();
    });
});
document.querySelectorAll(".side-nav-container .side-nav .guides li ul").forEach(function (dropdown) {
    var _a;
    var button = (_a = dropdown.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector("a");
    if (button) {
        button.addEventListener('click', function () {
            var _a, _b, _c;
            (_b = (_a = button === null || button === void 0 ? void 0 : button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('ul.child')) === null || _b === void 0 ? void 0 : _b.classList.toggle("d-none");
            (_c = button === null || button === void 0 ? void 0 : button.querySelector('img')) === null || _c === void 0 ? void 0 : _c.classList.toggle("open");
        });
    }
});
var headerBanner = document.querySelector(".header-banner-notification");
if (headerBanner) {
    var headerHeight = ((_f = document.querySelector("header")) === null || _f === void 0 ? void 0 : _f.clientHeight) || 0;
    var body = document.querySelector("body");
    if (body) {
        body.style.marginTop = "".concat(headerHeight, "px");
    }
}
(_g = document.querySelector("header .side-nav .earn-rewards button")) === null || _g === void 0 ? void 0 : _g.addEventListener("click", function () {
    // @ts-ignore
    SmileUI.openPanel();
});
